export default "/static/dashboard/build/app/img/v2/7dd87256f1230ab392a27946ce8fade9.png";